import React from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';

const HomePage = () => {

  return (
    <div className="home-container">
      <section className="hero-section">
        <div className="hero-content">
          <h1>Scopri il tuo prossimo mezzo con Tony Cars</h1>
          <p>Qualità, affare e stile si uniscono per offrirti il miglior viaggio. Sfoglia il nostro ampio catalogo di auto.</p>
          <Link to="/catalogo">Esplora il catalogo</Link>
        </div>
      </section>
    </div>
  );
  
};

export default HomePage;